import { useState } from "react";
import { BarChart3 } from "lucide-react";
import { rs } from "./PerfDashboard";

const Bars = ({ rows, metric }) => {
  const max = Math.max(1, ...rows.flatMap((r) => [r.a?.[metric] || 0, r.b?.[metric] || 0]));
  return (
    <div className="flex h-44 items-end gap-2 overflow-x-auto pb-1" data-testid="perf-bars">
      {rows.map((r) => (
        <div key={r.label} className="flex min-w-[34px] flex-1 flex-col items-center gap-1">
          <div className="flex h-36 w-full items-end justify-center gap-0.5">
            <div className="w-1/2 rounded-t bg-slate-500/60 transition-all" style={{ height: `${((r.b?.[metric] || 0) / max) * 100}%` }} title={`Last month: ${metric === "amount" ? rs(r.b?.amount) : r.b?.parcels || 0}`} />
            <div className="w-1/2 rounded-t bg-teal-400 transition-all" style={{ height: `${((r.a?.[metric] || 0) / max) * 100}%` }} title={`This month: ${metric === "amount" ? rs(r.a?.amount) : r.a?.parcels || 0}`} />
          </div>
          <span className="text-[10px] text-slate-400">{r.label}</span>
        </div>))}
    </div>
  );
};

export const PerfCompare = ({ d }) => {
  const [mode, setMode] = useState("week");
  const [metric, setMetric] = useState("parcels");
  const [day, setDay] = useState(d.day);
  const weeks = d.weeks.this.map((w, i) => ({ label: `W${i + 1}`, a: w, b: d.weeks.last[i] }));
  const days = d.days.map((x) => ({ label: String(x.day), a: x.this, b: x.last }));
  const pick = d.days.find((x) => x.day === Number(day)) || {};
  const btn = (on) => `rounded-lg px-3 py-1.5 text-xs font-semibold ${on ? "bg-teal-500 text-white" : "text-slate-300 hover:bg-white/10"}`;
  return (
    <div className="space-y-3 rounded-2xl border border-white/10 bg-[#0f1c2e] p-5" data-testid="perf-compare">
      <div className="flex flex-wrap items-center gap-2"><BarChart3 className="h-5 w-5 text-teal-400" /><b className="text-white">{d.month_label} vs {d.last_label}</b>
        <div className="ml-auto flex gap-1 rounded-lg bg-white/5 p-0.5">{[["week", "Weekly"], ["day", "Per day"]].map(([k, l]) => <button key={k} onClick={() => setMode(k)} className={btn(mode === k)} data-testid={`perf-mode-${k}`}>{l}</button>)}</div>
        <div className="flex gap-1 rounded-lg bg-white/5 p-0.5">{[["parcels", "Parcels"], ["amount", "₹ Business"]].map(([k, l]) => <button key={k} onClick={() => setMetric(k)} className={btn(metric === k)} data-testid={`perf-metric-${k}`}>{l}</button>)}</div>
      </div>
      <div className="flex gap-4 text-[11px] text-slate-400"><span className="flex items-center gap-1"><i className="h-2 w-2 rounded-sm bg-teal-400" />This month</span><span className="flex items-center gap-1"><i className="h-2 w-2 rounded-sm bg-slate-500" />Last month</span></div>
      <Bars rows={mode === "week" ? weeks : days} metric={metric} />
      {mode === "day" && (
        <div className="flex flex-wrap items-center gap-3 rounded-xl bg-white/5 p-3 text-sm text-white" data-testid="perf-day-pick">
          <span className="text-slate-400">Compare date</span>
          <select value={day} onChange={(e) => setDay(e.target.value)} className="rounded-lg bg-[#0b1524] px-2 py-1.5 text-white" data-testid="perf-day-select">
            {d.days.filter((x) => x.day <= d.days_in_month).map((x) => <option key={x.day} value={x.day}>{x.day} {d.month_label.split(" ")[0].slice(0, 3)} vs {x.day} {d.last_label.split(" ")[0].slice(0, 3)}</option>)}</select>
          <span data-testid="perf-day-this"><b className="text-teal-300">This month:</b> {pick.this?.parcels || 0} parcels · {rs(pick.this?.amount)}</span>
          <span data-testid="perf-day-last"><b className="text-slate-300">Last month:</b> {pick.last?.parcels || 0} parcels · {rs(pick.last?.amount)}</span>
        </div>)}
    </div>
  );
};
